const insuranceTypeLists = document.querySelectorAll('.insurance-type-list');
insuranceTypeLists.forEach((it) => {
	const cards = it.querySelectorAll('.insurance-type');

	const selectors = it.querySelectorAll('.insurance-types-selector');

	function normalize(value) {
		return value?.toString().toLowerCase().trim();
	}

	function updateCardsVisibility(selectedInsuranceType) {
		if (!cards || !cards.length) {
			return;
		}

		const normalizedSelectedType = normalize(selectedInsuranceType);

		cards.forEach((card) => {
			const cardType = card.getAttribute('data-insurance-type');
			const isVisible = normalize(cardType) === normalizedSelectedType;
			card.classList.toggle('hidden', !isVisible);
		});

		if (it && normalizedSelectedType) {
			it.setAttribute('data-insurance-filter', selectedInsuranceType);
		}

		it.dispatchEvent(
			new CustomEvent('insurance-type:change', { bubbles: false }),
		);
	}

	function styleLabelsByIndex(activeIndex) {
		const allLabels = it.querySelectorAll('.insurance-type-radio-label');
		// Aktiv-Markierung als inset-Ring statt Border: nimmt keinen Platz weg,
		// damit auf schmalen Screens (z. B. 402px) alle Tarifnamen vollständig passen.
		const borderClassesToReset = [
			'border-transparent',
			'border-primary-200',
			'border-[3px]',
			'ring-[3px]',
			'ring-inset',
			'ring-primary-200',
		];

		allLabels.forEach((label) => {
			const labelIndex = Number(label.dataset.index);
			const isActive = labelIndex === activeIndex;
			const input = label.querySelector('input[type="radio"]');

			if (input) {
				input.checked = isActive;
			}

			label.classList.remove(...borderClassesToReset);
			if (isActive) {
				label.classList.add('ring-[3px]', 'ring-inset', 'ring-primary-200');
			}
		});
	}

	function initInsuranceType() {
		if (!selectors.length) {
			console.log('No insurance type selectors!');
			return;
		}

		const firstSelector = selectors[0];
		const firstLabels = firstSelector.querySelectorAll(
			'.insurance-type-radio-label',
		);

		if (!firstLabels.length) {
			console.log('No insurance type radio labels!');
			return;
		}

		let initialType = it?.getAttribute('data-insurance-filter') || null;
		let activeIndex = 0;

		if (initialType) {
			const normalizedInitial = normalize(initialType);

			firstLabels.forEach((label) => {
				const input = label.querySelector('input[type="radio"]');
				if (!input) {
					return;
				}

				if (normalize(input.value) === normalizedInitial) {
					activeIndex = Number(label.dataset.index);
					initialType = input.value; // auf exakt diesen Wert setzen
				}
			});
		} else {
			const firstLabel = firstLabels[0];
			const firstInput = firstLabel.querySelector('input[type="radio"]');
			if (firstInput) {
				initialType = firstInput.value;
				activeIndex = Number(firstLabel.dataset.index);
				firstInput.checked = true;
			}
		}

		if (!initialType) {
			console.log('No initial insurance type determined');
			return;
		}

		updateCardsVisibility(initialType);
		styleLabelsByIndex(activeIndex);

		selectors.forEach((selector) => {
			selector.addEventListener('change', (event) => {
				const target = event.target;
				if (!target || !target.matches('input[type="radio"]')) {
					return;
				}

				const label = target.closest('.insurance-type-radio-label');
				if (!label) {
					return;
				}

				const index = Number(label.dataset.index);

				updateCardsVisibility(target.value);
				styleLabelsByIndex(index);
			});

			const labels = selector.querySelectorAll('.insurance-type-radio-label');
			labels.forEach((label) => {
				const input = label.querySelector('input[type="radio"]');
				if (!input) return;

				label.addEventListener('keydown', (event) => {
					if (event.key !== 'Enter' && event.key !== ' ') return;
					event.preventDefault();

					const index = Number(label.dataset.index);
					updateCardsVisibility(input.value);
					styleLabelsByIndex(index);
				});
			});
		});
	}

	initInsuranceType();
});
